
/**
 * Module dependencies.
 */

import { QueryClient } from 'react-query';
import { fetchProductApplications } from 'src/api/app/products/fetch-product-applications';
import { fetchTopBarMenu } from 'src/api/app/top-bar-menu/fetch-top-bar-menu';

/**
 * Export `prefetchNavbarQueries`.
 *
 * Warms the two queries the navbar needs on first paint: the back-office links
 * of the pre navbar and the product applications listed under `Coleções`.
 * Without this both pop in after hydration, and the mega menu renders with one
 * column missing until the request lands.
 *
 * The keys have to mirror `useTopBarMenu` and `useProductApplications` exactly,
 * otherwise the cache is warmed under a key nobody reads.
 */

async function prefetchNavbarQueries(queryClient: QueryClient, locale: string): Promise<void> {
  const variables = { locale };

  try {
    await Promise.all([
      queryClient.prefetchQuery(`${locale}-top-bar-menu`, () => {
        return fetchTopBarMenu(variables);
      }),
      queryClient.prefetchQuery([`${locale}-product-applications`, variables], () => {
        return fetchProductApplications(variables);
      })
    ]);
  } catch {
    // The navbar degrades on its own, so a slow or broken API must never take
    // the whole page down with it.
  }
}

/**
 * Export `prefetchNavbarQueries`.
 */

export default prefetchNavbarQueries;
